import { render, staticRenderFns } from "./layout-options.component.vue?vue&type=template&id=b5b609f8&"
import script from "./layout-options.component.ts?vue&type=script&lang=ts&"
export * from "./layout-options.component.ts?vue&type=script&lang=ts&"
import style0 from "./layout-options.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
